import { createContext } from 'react';

import { appHistory } from '../../router/history';

/**
 * The history the app Link navigates with. Defaults to the web app's browser
 * history; the Adobe panel and DaVinci Resolve hosts embed web pages inside
 * their own react-router v5 memory routers and provide their history instead.
 */
export type LinkHistory = {
  push: (path: string) => void;
  replace: (path: string) => void;
};

export const LinkHistoryContext = createContext<LinkHistory>(appHistory);
